import { Config } from './index';
import baseConfig from './base-config';

const config: Config = {
  ...baseConfig,
  api: 'https://global-robertsradio-prd.gd-commerce-services.net',
  brandName: 'Roberts',
  country: '',
  supportedCountries: [],
  commercetools: {
    projectKey: 'global-robertsradio-prd',
    clientId: '',
    clientSecret: '',
    store: '',
  },
  currency: '',
  bazaarvoiceUrl:
    'https://api.bazaarvoice.com/notifications/rsa_encryption_key/public/current/?passkey=pedpamuvhnprx4hazkqe9xwt',
  googleMerchantId: 'BCR2DN6T3OBOFRAY',
  loqateApiKey: 'WY45-FF59-UG77-NC91',
  paymentEnvironment: 'production',
  paymentMethods: {
    applePay: true,
    googlePay: true,
    paypal: true,
  },
  theme: 'robertsradio',
  textKeys: {
    deliveryCountryContext: 'deliveryCountryContextLabel.robertsradio',
    deliveryPostalCodeContext: 'deliveryPostalCodeContextLabel.robertsradio',
    findRetailer: 'findRetailer.robertsradio',
  },
  urls: {
    basket: '/basket',
    checkout: '/checkout',
    confirmation: '/confirmation',
    getInTouch: '/contact-us',
    privacyPolicy: '/privacy-policy',
    shippingAndReturns: '/returns-policy',
    termsConditions: '/terms-of-use',
    catalog: '/shop',
    retailer: '',
    upsellOverview: '',
  },
  showCrossSellCta: true,
  countryMapping: {
    GB: {
      currency: 'GBP',
      supportedCountries: ['GB'],
      commercetools: {
        projectKey: 'global-robertsradio-prd',
        clientId: 'dCDVndw1Bh2Va3wBWF3SVREK',
        clientSecret: 'dxKKI7OBL9xDJIQvYu628rx960yluVN6',
        store: 'robertsradio',
      },
      textKeys: {
        deliveryCountryContext: 'deliveryCountryContextLabel.robertsradio',
        deliveryPostalCodeContext: 'deliveryPostalCodeContextLabel.robertsradio',
        findRetailer: 'findRetailer.robertsradio',
      },
      features: {
        ...baseConfig.features,
        enableCartOptimisticResponse: true,
        crossSelling: true,
        displayLinkToPDP: true,
        marketingOptInExplicit: true,
      },
    },
    FR: {
      currency: 'EUR',
      supportedCountries: ['FR'],
      locale: 'fr-FR',
      commercetools: {
        store: 'FR',
        clientId: 'vDpQjoL6tO_I56IyoHUsuQqb',
        clientSecret: 'maUwthX3hv6OpK1Qkcjvv6P5-8sdHbZ0',
        projectKey: 'global-robertsradio-prd',
      },
      textKeys: {
        deliveryCountryContext: 'deliveryCountryContextLabel.robertsradio',
        findRetailer: 'findRetailer.robertsradio',
      },
      features: {
        ...baseConfig.features,
        enableCartOptimisticResponse: true,
        crossSelling: true,
        displayLinkToPDP: true,
        termsAndConditionsCheckbox: true,
      },
    },
  },
};

export default config;
